import {
  JOBS_URL,
  JOB_URL,
  SEARCH_JOBS_URL,
  JOB_MOMENTS_URL,
  DELETE_DEFAULT_MOMENT,
  SIMPLE_JOBS_URL,
  JOB_QRCODE_TEMPLATE_URL,
  QR_GEN_URL,
  QR_GEN_TEMPLATES_URL,
  QR_REMOVE_TEMPLATES_URL
} from 'app/utils/Constants';

import {
  get,
  post,
  put,
  patch
} from 'app/services/ApiService';

import {
  TEXT,
  EQUALS
} from 'app/hooks/useFilter';

export const getJob = async id => {
  let params = {
    page: 1,
    per_page: 1,
    filter_model: {
      id: [{
        filterClass: TEXT,
        filterType: EQUALS,
        value: id.toString()
      }]
    },
    sort_model: []
  }

  let resp = await getJobs(params);
  return resp.records[0];
}

export const getJobs = async params => {
  return await post(SEARCH_JOBS_URL(), params);
}

// TODO: Currently being used in Autocompletes due to quicker response time
// Nothing technically wrong with that, but Autocomplete does end up making unnecessary calls to the server
export const getSimpleJobs = async (page = 1, perPage = 500, jobs = []) => {
  return get(SIMPLE_JOBS_URL(page, perPage))
    .then((jobsPage) => {
      jobsPage = jobsPage ?? []
      jobs = jobs.concat(jobsPage);

      if (jobsPage.length === perPage) {
        return getSimpleJobs(page + 1, perPage, jobs)
      }

      return Promise.resolve(jobs);
    })
}

export const createJob = async params => {
  params.portal2 = true;
  return await post(JOBS_URL(), params);
}

export const updateJob = async (id, params) => {
  params.portal2 = true;
  return await put(JOB_URL(id), params);
}

export const destroyJobs = async ids => {
  let params = { ids };
  return await patch(JOBS_URL(), params);
}

export const getJobMoments = async (id, page, perPage) => {
  return await get(JOB_MOMENTS_URL(id, page, perPage));
}

export const deleteDefaultMoment = async (jobId, momentId) => {
  return await destroy(DELETE_DEFAULT_MOMENT(jobId, momentId));
}

export const getQRCodeGenTemplates = async (jobId) => {
  return await get(QR_GEN_TEMPLATES_URL(jobId));
}

export const generateQRCodeCards = async (jobId, params) => {
  return await post(QR_GEN_URL(jobId), params);
}

export const getQrCodeGenJobs = async (jobId, params) => {
  return await get(QR_GEN_URL(jobId));
}

export const removeQRCodeTemplates = async (jobId, params) => {
  return await post(QR_REMOVE_TEMPLATES_URL(jobId), params);
}

export const notifyCustomers = () => null;

export const getQrCodeTemplateUrl = async jobId => {
  return await get(JOB_QRCODE_TEMPLATE_URL(jobId));
}
